import React from 'react';

const Footer = () => {
    return (
        <div className="text-center" style={{ background: "#efefef", padding: "7px 5px" }}>
            <p className="text-muted">Copyright 2021 Sujan</p>
        </div>
    );
}

export default Footer;
